import { useState, useContext } from 'react';
import { Eye } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditPlanService from '../../../../../../../services/audit_services/auditPlanService';

export default function PublishModal({ isOpen, onClose, planId, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handlePublish = async () => {
    setLoading(true);
    
    try {
      const result = await auditPlanService.publishAuditPlan(authTokens.access, planId);
      
      if (result.success) {
        showSuccess('Plan d\'audit publié avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors de la publication du plan d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error publishing audit plan:', error);
      showError('Error publishing audit plan');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handlePublish}
      title="Publier le plan d'audit"
      message="Êtes-vous sûr de vouloir publier ce plan d'audit ? Cela rendra les résultats de l'audit visibles aux parties prenantes."
      confirmText={loading ? 'Publication...' : 'Publier'}
      confirmButtonClass="bg-green-600 hover:bg-green-700"
      icon={<Eye className="h-6 w-6 text-green-600" />}
      loading={loading}
    />
  );
}
